<template>
  <div class="advantageMachine">
    <div>
      <img src="../assets/images/picture_08.png" alt="">
      <div class="ideaText">
        <div class="fz28">“行业领先的事业合伙人机制——「鲲鹏计划」”</div>
      </div>
    </div>
    <div class="compText">
      即期佣金收入、中期盈利分润、远期股权合伙，打造“共创”、“共担”、“共赢”的事业共同体，让保险众创平台真正成为优秀保险顾问、团队和机构的众创共享之家。
    </div>
    <div class="forItem">
      <img src="../assets/images/picture_44.png" alt="">
      <div class="fz20 c666">
        我们为客户提供市场上最专业、体验最好的保险售前与售中服务,和频而不烦、多元化的售后与增值服务。用最优质的代理人队伍传递“需求定制+严格甄选”的专业品质。
      </div>
    </div>
    <div class="forItem">
      <img src="../assets/images/picture_43.png" alt="">
      <div class="fz20 c666">
        我们为代理人打造能赢向未来的可持续发展平台,这里不仅有一流的营销体系,更有极具竞争力的制度优势,回归本源倡导专业销售,扁平化架构打破地域壁垒。
      </div>
    </div>
    <div>
      <img src="../assets/images/picture_35.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'advantageMachine',
  components: {},
  data() {
    return {

    }
  },
  computed: {},
  created() { },
  mounted() { },
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.advantageMachine {
  width: 1024px;
  margin: 0 auto;

  &>div {
    margin-top: 40px;
    position: relative;

    .ideaText {
      width: 100%;
      color: #ffffff;
      position: absolute;
      top: 192px;
      text-align: center;

      &>div:first-child {
        font-weight: 600;
      }
    }

    img {
      width: 100%;
    }
  }

  .forItem {
    position: relative;

    img {
      width: 136px;
      position: absolute;
      left: 0;
    }

    div {
      width: 1024px;
      height: 136px;
      background: #F8F8F8;
      border-radius: 68px;
      padding: 40px 40px 40px 148px;
    }
  }

  .highLightTitle {
    text-align: center;
  }

}
</style>